import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS, COLORS, ComponentTextStyle, focusStyles } from '../../styles/index';
import { ComponentMStyling, ComponentSStyling } from '../../styles';
import { Size } from '../../types';

export const SearchFieldWrapper = styled.div`
  &.focus-visible-within {
    ${focusStyles}
  }
`;

export const StyledSearchField = styled.div<{ activeValidationMessage?: boolean }>`
  display: flex;
  flex-direction: row;
  box-shadow: inset 0 0 0 1px ${COLORS.neutral_400};
  margin-bottom: 4px;
  box-sizing: border-box;
  border-radius: 56px;
  align-items: center;
  position: relative;
  height: 48px;
  appearance: none;
  background-color: ${COLORS.white};

  ${ComponentSStyling(ComponentTextStyle.Regular, COLORS.black)}

  padding: 0 !important;
  width: 100%;

  ::placeholder {
    ${ComponentSStyling(ComponentTextStyle.Italic, COLORS.neutral_500)}
  }

  ${BREAKPOINTS.MEDIUM} {
    ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.black)}

    height: 56px;
    padding: 0 4px !important;

    &::placeholder {
      ${ComponentMStyling(ComponentTextStyle.Italic, COLORS.neutral_500)}
    }
  }

  &.small {
    ${ComponentSStyling(ComponentTextStyle.Regular, COLORS.black)}
    height: 48px;
    padding: 0 !important;

    &::placeholder {
      ${ComponentSStyling(ComponentTextStyle.Italic, COLORS.neutral_500)}
    }
  }

  &.medium {
    ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.black)}
    height: 56px;

    &::placeholder {
      ${ComponentMStyling(ComponentTextStyle.Italic, COLORS.neutral_500)}
    }
  }

  &:hover {
    box-shadow: inset 0 0 0 2px ${COLORS.primary_800};
  }

  &:focus-within {
    box-shadow: inset 0 0 0 2px ${COLORS.primary_800};
  }

  div {
    color: ${COLORS.neutral_600};
    background-color: transparent;
  }

  &.invalid {
    box-shadow: inset 0 0 0 2px ${COLORS.critical_400};
  }

  &.disabled {
    box-shadow: inset 0 0 0 1px ${COLORS.neutral_100};
    pointer-events: none;
    background-color: transparent !important;
  }
`;

type SeachFieldProps = React.HTMLAttributes<HTMLDivElement> & {
  id: string;
  searchTerm?: string;
  disabled?: boolean;
  validationMessage?: string;
  children: any;
  size?: Size.Small | Size.Medium;
};

const SearchField = React.forwardRef<HTMLDivElement, SeachFieldProps>(({ id, searchTerm, disabled, validationMessage, children, size, className, ...rest }, ref) => {
  const cls = (disabled ? 'disabled ' : '')
    .concat(searchTerm !== '' ? 'searchactive ' : '')
    .concat(size ? `${size} ` : '')
    .concat(validationMessage ? ' invalid ' : '')
    .concat(`${className ?? ''} `);

  return (
    <SearchFieldWrapper ref={ref}>
      <StyledSearchField id={`${id}_main`} data-testid={`${id}_main`} className={cls} {...rest}>
        {children}
      </StyledSearchField>
    </SearchFieldWrapper>
  );
});

export default SearchField;
